import {useEffect, useRef} from 'react';
import {noop} from 'shared/tools';
import {locale} from 'shared/core';
/*global $ */

const InlineDatePicker = ({value, onChange = noop, options = {}}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const $picker = $(containerRef.current).datepicker({
      language: locale,
      ...options
    }).on('changeDate', e => onChange(e.date));

    if (value) $picker.datepicker('update', value);

    return () => $picker.datepicker('destroy');
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;

    const current = $(containerRef.current).datepicker('getDate');
    const next = value || null;

    if (current?.getTime() === next?.getTime()) return;

    $(containerRef.current).datepicker('update', next);
  }, [value]);

  const lockedViewUnit = options.maxViewMode === 0;

  return <div ref={containerRef} className={`InlineDatePicker${lockedViewUnit ? ' InlineDatePicker--lockedViewUnit' : ''}`}/>;
};

export default InlineDatePicker;
